import { observer } from 'mobx-react';
import { Icon } from 'office-ui-fabric-react/lib/Icon';
import * as React from 'react';
import { InfoBarMessageViewState } from '../schema/InfoBarMessageViewState';
import InfoBarMessagePart from './InfoBarMessagePart';
import getInfoBarIconColor from '../utils/getInfoBarIconColor';
import getInfoBarIcon from '../utils/getInfoBarIcon';

const styles = require('./InfoBarMessage.scss');
const classNames = require('classnames/bind').bind(styles);

@observer
export default class InfoBarMessage extends React.Component<InfoBarMessageViewState, any> {
    render() {
        const infoBarIconColor = getInfoBarIconColor(this.props.rank, this.props.color);
        const iconName = getInfoBarIcon(this.props.rank);
        const textContainerStyle = classNames(
            styles.textContainer,
            styles.textContainerMarginForNewInfoBarUI,
            this.props.textContainerClassName
        );

        return (
            <div className={classNames(styles.container, styles.newInfoBarUI)}>
                <Icon iconName={iconName} className={classNames(styles.icon, infoBarIconColor)} />
                <div className={textContainerStyle}>
                    {this.props.messageElement
                        ? React.cloneElement(this.props.messageElement, {
                              colorScheme: this.props.colorScheme,
                          })
                        : this.props.messageParts.map((part, index) => (
                              <span key={index}>
                                  <InfoBarMessagePart
                                      messagePart={part}
                                      colorScheme={this.props.colorScheme}
                                  />
                                  {index != this.props.messageParts.length - 1 ? ' ' : null}
                              </span>
                          ))}
                </div>
            </div>
        );
    }
}
